import { render, staticRenderFns } from "./FloatingWidgetCustomizer.vue?vue&type=template&id=edf61022&"
import script from "./FloatingWidgetCustomizer.vue?vue&type=script&lang=js&"
export * from "./FloatingWidgetCustomizer.vue?vue&type=script&lang=js&"
import style0 from "./FloatingWidgetCustomizer.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports